import type { FetchSiteOptionsResponse } from 'services/content/site-options/types'

// function megaMenuSectionNodeParser(sectionId) {
//   return (node, index) => {
//     const { acfFcLayout, ...props } = node
//     const name = pascalize(acfFcLayout)
//     const id = `${sectionId}-${index}`

//     return { name, id, ...props }
//   }
// }

// function megaMenuParser(entity, megaMenuId) {
//   const { megaMenuSections = [], ...rest } = entity
//   return {
//     ...rest,
//     sections: megaMenuSections.map((section, index) => {
//       const { nodes, ...rest } = section
//       const id = `${megaMenuId}-${index}`

//       return {
//         ...rest,
//         id,
//         nodes: nodes.map(megaMenuSectionNodeParser(id)),
//       }
//     }),
//   }
// }

// function headerBrandLinksParser(links: RawMenu[]) {
//   console.log('links', links)
//   return links.map((link) => {
//     const { megaMenu = {}, id, ...rest } = link

//     return {
//       ...rest,
//       megaMenu: megaMenuParser(megaMenu, id),
//     }
//   })
// }

export default (data: FetchSiteOptionsResponse) => {
  const {
    brandBarMenu,
    footerMainMenu,
    footerBrandBarMenu,
    footerSocialMenu,
    footerContactMenu,
    footerLegalMenu,
    headerMainMenu,
    headerMainMenuText,
  } = data.menus

  let mainLinks = footerMainMenu.links || []

  mainLinks = mainLinks.map((link) => ({
    ...link,
    below: link.below || [],
  }))

  const mobileBrandBar = brandBarMenu.links.map((link) => {
    return {
      text: link.text,
      links: link.below.map((links) => {
        const { text, url, below } = links
        return {
          text,
          url,
          below,
        }
      }),
    }
  })

  const mobileMainLinks = {
    text: headerMainMenuText,
    links: headerMainMenu.links || [],
  }

  const mobileMenuLinks = [...mobileBrandBar, mobileMainLinks]

  return {
    header: {
      desktopLinks: headerMainMenu.links || [],
      mobileLinks: mobileMenuLinks,
      brandLinks: brandBarMenu.links || [],
    },
    footer: {
      mainLinks,
      brandLinks: footerBrandBarMenu.links || [],
      socialLinks: footerSocialMenu.links || [],
      contactLinks: footerContactMenu.links || [],
      legalLinks: footerLegalMenu.links || [],
    },
  }
}
